import Swal from "sweetalert2";

export default Swal.mixin({
  showClass: { backdrop: 'swal2-noanimation', popup: '', },
  hideClass: { popup: '' },
  customClass: {
    cancelButton: 'btn btn-gray-primary',
    confirmButton: 'btn btn-primary',
    denyButton: 'btn btn-gray-primary',
    actions: 'flex justify-content-center items-center gap-2 flex-wrap',
  },
  buttonsStyling: false,
})